import { useNavigate } from 'react-router-dom'
import HeadingText from '../../ActionCommonComponent/HeadingText'

const EditRevisionAction = ({data}) => {
    const navigate = useNavigate()
    const { version_id } = data
  return (
    <HeadingText heading="Associated Version" text={version_id}>
        &nbsp;&nbsp;<button className="btn-outline-primary" 
        onClick={()=>navigate("/audit-trail/preview-current-node/"+data?.audit_trail_id)}>Preview</button>
    </HeadingText>
  )
}

export default EditRevisionAction